module.exports = __webpack_public_path__ + "static/img/part2-dis.831276b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/part2-dis.png
// module id = qqY8
// module chunks = 1